import { FC } from "react";
import { useTranslation } from "react-i18next";
import { TextInput, useMuiController } from "@sinch/components/index";

export const CreateComponentDescriptionField: FC = () => {
  const { t } = useTranslation();
  const { field } = useMuiController({ name: "description" });
  return <TextInput multiline {...field} fullWidth label={t("description")} maxRows={20} minRows={3} />;
};
